/* Lumori Cinema – Vanilla JS, keine Abhängigkeiten */
(function () {
  'use strict';
  var L = window.Lumori || { routes: {}, strings: {} };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noAnim = document.body.classList.contains('no-anim') || reduced;
  var O = L.opts || {};
  var root = document.documentElement;
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Header: transparent über Hero, dunkel beim Scrollen ---------- */
  var header = $('[data-header]');
  var hasHero = !!$('[data-hero]');
  if (header) {
    var announce = $('.announce');
    var setH = function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
      /* Ankündigungsleiste schiebt den Hero nach unten – Höhe abziehen, damit Zähler/Scroll-Label im Bild bleiben */
      document.documentElement.style.setProperty('--announce-h', (announce ? announce.offsetHeight : 0) + 'px');
    };
    var onScroll = function () {
      var top = window.scrollY < 40;
      header.classList.toggle('is-top', top && hasHero && header.hasAttribute('data-transparent'));
    };
    if (hasHero && header.hasAttribute('data-transparent')) document.body.classList.add('has-overlay-header');
    setH();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setH);
  }

  /* ---------- Scroll-Reveals ---------- */
  var reveals = $$('[data-reveal],[data-fade]');
  if (noAnim || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax (Split-Screen) ---------- */
  var parallax = noAnim ? [] : $$('[data-parallax]');
  if (parallax.length) {
    var ticking = false;
    var run = function () {
      parallax.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'translate3d(0,' + (p * -10).toFixed(2) + '%,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Schicht für Schicht: Druck-Reveal ([data-print]) ---------- */
  /* --p = Druckfortschritt 0..1, quantisiert in Schichten; Kante, Druckkopf und Schichtlinien laufen nur über transform/opacity. */
  var printOn = root.classList.contains('js-print') && !noAnim;
  function printNum(el, name, def) { var v = parseFloat(el.getAttribute(name)); return v > 0 ? v : def; }
  function pad3(n) { return ('00' + n).slice(-3); }
  function printMeasure(st) {
    st.h = st.el.offsetHeight; st.w = st.el.offsetWidth;
    st.el.style.setProperty('--ph', st.h + 'px');
  }
  function printFinish(st, instant) {
    var el = st.el;
    el.style.setProperty('--p', '1');
    el.style.removeProperty('--hx');
    el.classList.remove('is-printing');
    el.classList.add('is-printed');
    st.scope.classList.remove('is-printing');
    st.scope.classList.add('is-printed');
    if (st.count) { st.count.textContent = st.word + ' ' + pad3(st.layers) + ' / ' + pad3(st.layers) + ' · ' + st.unit; }
    if (!instant) setTimeout(function () { st.fx.forEach(function (f) { if (f.parentNode) f.parentNode.removeChild(f); }); }, 450);
    else st.fx.forEach(function (f) { if (f.parentNode) f.parentNode.removeChild(f); });
    el.dispatchEvent(new CustomEvent('printdone', { bubbles: true }));
  }
  function printRun(st) {
    var el = st.el, t0 = 0, lastLayer = -1;
    printMeasure(st);
    el.classList.add('is-printing');
    st.scope.classList.add('is-printing');
    el.dispatchEvent(new CustomEvent('printstart', { bubbles: true }));
    function frame(now) {
      if (!t0) t0 = now;
      var t = clamp((now - t0) / st.duration, 0, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var pos = eased * st.layers, layer = Math.floor(pos);
      if (t >= 1) { printFinish(st, false); return; }
      el.style.setProperty('--p', (layer / st.layers).toFixed(5));
      var frac = pos - layer;
      el.style.setProperty('--hx', ((layer % 2 === 0 ? frac : 1 - frac) * st.w).toFixed(1) + 'px');
      if (st.count && layer !== lastLayer) {
        lastLayer = layer;
        st.count.textContent = st.word + ' ' + pad3(Math.max(1, layer)) + ' / ' + pad3(st.layers) + ' · ' + st.unit;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function printStart(el) {
    var st = el._print;
    if (!st || st.started) return;
    st.started = true;
    /* Erst drucken, wenn das Medium da ist – sonst „druckt“ die Kante eine leere Fläche (lazy-Bilder). Max. 1,5 s warten. */
    var go = function () { if (st.delay > 0) setTimeout(function () { printRun(st); }, st.delay); else printRun(st); };
    var media = el.querySelector('img,video');
    var ready = !media || (media.tagName === 'VIDEO' ? media.readyState >= 2 : (media.complete && media.naturalWidth > 0));
    if (ready) { go(); return; }
    var done = false, once = function () { if (!done) { done = true; go(); } };
    if (media.tagName === 'IMG') { media.loading = 'eager'; if (media.decode) media.decode().then(once, once); media.addEventListener('load', once, { once: true }); }
    else media.addEventListener('loadeddata', once, { once: true });
    media.addEventListener('error', once, { once: true });
    setTimeout(once, 1500);
  }
  window.LumoriPrint = function (el) { if (el) printStart(el); };
  $$('[data-print]').forEach(function (el) {
    var scope = el.closest('[data-print-scope]') || el;
    var counterSel = el.getAttribute('data-print-counter');
    var count = counterSel ? $(counterSel, scope) : null;
    var st = el._print = {
      el: el, scope: scope, started: false, fx: [], h: 0, w: 0, count: count,
      layers: Math.round(printNum(el, 'data-print-layers', 90)),
      duration: printNum(el, 'data-print-duration', 1800),
      delay: printNum(el, 'data-print-delay', 0),
      word: count ? (count.getAttribute('data-word') || '') : '',
      unit: count ? (count.getAttribute('data-unit') || '') : ''
    };
    if (!printOn) { st.started = true; printFinish(st, true); return; }
    ['front', 'lines', 'head'].forEach(function (n) {
      var f = document.createElement('span');
      f.className = 'print__fx print__' + n; f.setAttribute('aria-hidden', 'true');
      el.appendChild(f); st.fx.push(f);
    });
    window.addEventListener('resize', function () { if (st.started && !el.classList.contains('is-printed')) printMeasure(st); });
    var mode = el.getAttribute('data-print');
    if (mode === 'manual') return;
    if (el.getAttribute('data-print-start') === 'load' || !('IntersectionObserver' in window)) { printStart(el); return; }
    var pio = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { pio.disconnect(); printStart(el); }
    }, { threshold: 0.25 });
    pio.observe(el);
  });

  /* ---------- Intro „Licht an“ ---------- */
  function heroReady() {
    $$('[data-hero]').forEach(function (h) {
      h.classList.add('is-ready');
      var pr = $('[data-print="manual"]', h);
      if (pr) window.LumoriPrint(pr); /* Druck-Intro startet, sobald „Licht an“ endet */
    });
  }
  var introEl = $('[data-intro]');
  if (introEl && root.classList.contains('intro-on')) {
    var introDone = false;
    var introOut = function () {
      if (introDone) return;
      introDone = true;
      introEl.classList.add('is-out');
      heroReady();
      setTimeout(function () { root.classList.remove('intro-on'); }, 700);
    };
    setTimeout(introOut, parseInt(introEl.getAttribute('data-ms'), 10) || 1200);
    ['click', 'keydown', 'touchstart'].forEach(function (ev) { document.addEventListener(ev, introOut, { once: true, passive: true }); });
  } else {
    heroReady();
  }

  /* ---------- Hero: Video bei reduzierter Bewegung anhalten ---------- */
  if (reduced) { $$('.hero video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); }

  /* ---------- Überschriften Wort für Wort ---------- */
  if (!noAnim && O.words !== false && 'IntersectionObserver' in window) {
    var wio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-words-in'); wio.unobserve(e.target); } });
    }, { threshold: 0.35 });
    $$('.section__head .h2, [data-words]').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (!t) return;
      el.setAttribute('aria-label', t);
      el.textContent = '';
      t.split(/\s+/).forEach(function (word, i) {
        var w = document.createElement('span'), inner = document.createElement('span');
        w.className = 'w'; w.setAttribute('aria-hidden', 'true'); w.style.setProperty('--i', i);
        inner.textContent = word; w.appendChild(inner);
        el.appendChild(w); el.appendChild(document.createTextNode(' '));
      });
      el.classList.add('is-words');
      wio.observe(el);
    });
  }

  /* ---------- Scroll-gekoppelt: Hero, Manifest, Lookbook ---------- */
  var heroEl = noAnim ? null : $('[data-hero-parallax]');
  var manifests = noAnim ? [] : $$('[data-manifest]').map(function (el) {
    return { el: el, words: $$('.mf__w', el), min: parseFloat(el.getAttribute('data-min')) || 0.2 };
  });
  var lookbooks = $$('[data-lookbook]').map(function (el) {
    return { el: el, pin: $('.lookbook__pin', el), track: $('[data-lookbook-track]', el), bar: $('[data-lookbook-bar]', el), dist: 0, on: false };
  });
  var wide = window.matchMedia('(min-width: 990px)');
  function lbSetup() {
    lookbooks.forEach(function (lb) {
      lb.on = wide.matches && !noAnim;
      lb.el.classList.toggle('is-pinned', lb.on);
      if (lb.on) {
        lb.dist = Math.max(0, lb.track.offsetWidth - lb.pin.clientWidth + 2 * parseFloat(getComputedStyle(root).fontSize));
        lb.el.style.height = (window.innerHeight + lb.dist) + 'px';
      } else {
        lb.el.style.height = '';
        lb.track.style.transform = '';
      }
    });
    scrollFx();
  }
  function scrollFx() {
    var vh = window.innerHeight;
    if (heroEl) {
      var hh = heroEl.offsetHeight, y = window.scrollY;
      if (y <= hh) heroEl.style.setProperty('--hp', clamp(y / hh, 0, 1).toFixed(3));
    }
    manifests.forEach(function (m) {
      var r = m.el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 1.2) return;
      var n = m.words.length;
      var p = clamp((vh * 0.85 - r.top) / (vh * 0.4 + r.height), 0, 1);
      m.words.forEach(function (w, i) {
        w.style.opacity = (m.min + (1 - m.min) * clamp((p * (n + 2) - i) / 2, 0, 1)).toFixed(3);
      });
    });
    lookbooks.forEach(function (lb) {
      if (!lb.on) return;
      var r = lb.el.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(1, r.height - window.innerHeight), 0, 1);
      lb.track.style.transform = 'translate3d(' + (-p * lb.dist).toFixed(1) + 'px,0,0)';
      if (lb.bar) lb.bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    });
  }
  if (heroEl || manifests.length || lookbooks.length) {
    var fxTick = false;
    window.addEventListener('scroll', function () { if (!fxTick) { fxTick = true; requestAnimationFrame(function () { fxTick = false; scrollFx(); }); } }, { passive: true });
    window.addEventListener('resize', lbSetup);
    window.addEventListener('load', lbSetup);
    if (wide.addEventListener) wide.addEventListener('change', lbSetup);
    lbSetup();
  }

  /* ---------- Lichtkegel ---------- */
  $$('[data-lightrev]').forEach(function (sec) {
    if (noAnim) return;
    var x = 0, y = 0, tx = 0, ty = 0, last = 0, seen = false, raf = 0, started = false;
    function dims() { var r = sec.getBoundingClientRect(); return r; }
    function frame(now) {
      raf = 0;
      if (!seen) return;
      var r = dims();
      if (!started) { x = tx = r.width / 2; y = ty = r.height / 2; started = true; }
      if (now - last > 2500) {
        tx = r.width * (0.5 + 0.32 * Math.sin(now * 0.00035));
        ty = r.height * (0.5 + 0.26 * Math.sin(now * 0.00052 + 1));
      }
      x += (tx - x) * 0.1; y += (ty - y) * 0.1;
      sec.style.setProperty('--x', x.toFixed(1) + 'px');
      sec.style.setProperty('--y', y.toFixed(1) + 'px');
      raf = requestAnimationFrame(frame);
    }
    function aim(e) {
      var r = dims();
      tx = e.clientX - r.left; ty = e.clientY - r.top; last = performance.now();
      if (!started) { x = tx; y = ty; started = true; }
    }
    sec.addEventListener('pointermove', aim, { passive: true });
    sec.addEventListener('pointerdown', aim, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        seen = en[0].isIntersecting;
        if (seen && !raf) raf = requestAnimationFrame(frame);
      }).observe(sec);
    }
  });

  /* ---------- Produktkarten: warmer Lichtschein an der Maus ---------- */
  if (!noAnim) {
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || !e.target.closest) return;
      var m = e.target.closest('.card__media');
      if (!m) return;
      var r = m.getBoundingClientRect();
      m.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
      m.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
    }, { passive: true });
  }

  /* ---------- Seitenübergänge (Fallback ohne View-Transitions-API) ---------- */
  if (O.transitions && !O.designMode && !noAnim && !('CSSViewTransitionRule' in window)) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-open')) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin || /^\/(checkout|cart\/|admin)/.test(u.pathname)) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      e.preventDefault();
      root.classList.add('is-leaving');
      setTimeout(function () { location.href = a.href; }, 200);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('is-leaving'); });
  }

  /* ---------- Drawer ---------- */
  var activeDrawer = null, lastTrigger = null;
  function openDrawer(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    if (activeDrawer) closeDrawer();
    d.hidden = false;
    if (id === 'cart-drawer') loadUpsell(d);
    activeDrawer = d; lastTrigger = trigger || null;
    document.documentElement.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var f = d.querySelector('input,button,a');
    if (id === 'search-drawer') { f = $('#SearchInput'); }
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger) { lastTrigger.setAttribute('aria-expanded', 'false'); lastTrigger.focus(); }
    activeDrawer = null; lastTrigger = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.getAttribute('data-open') === 'cart-drawer' && !document.getElementById('cart-drawer')) return;
      e.preventDefault();
      openDrawer(opener.getAttribute('data-open'), opener);
      return;
    }
    if (e.target.closest('[data-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && activeDrawer) {
      var f = $$('a[href],button:not([disabled]),input,summary', activeDrawer).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Predictive Search ---------- */
  var pInput = $('[data-predictive]');
  var pOut = $('[data-predictive-results]');
  if (pInput && pOut) {
    var timer = null, ctl = null;
    var fmt = function (v) {
      try { return new Intl.NumberFormat(L.locale || 'de', { style: 'currency', currency: L.currency || 'EUR' }).format(parseFloat(v)); }
      catch (err) { return v; }
    };
    pInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = pInput.value.trim();
      if (q.length < 2) { pOut.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctl) ctl.abort();
        ctl = window.AbortController ? new AbortController() : null;
        var url = (L.routes.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8';
        fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { pOut.innerHTML = '<p class="muted"></p>'; pOut.firstChild.textContent = L.strings.noResults || ''; return; }
          var ul = document.createElement('ul'); ul.className = 'suggest';
          items.forEach(function (p) {
            var li = document.createElement('li'), a = document.createElement('a');
            a.href = p.url;
            if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.width = 200; im.height = 200; a.appendChild(im); }
            var t = document.createElement('span'); t.textContent = p.title; a.appendChild(t);
            var pr = document.createElement('span'); pr.className = 'muted'; pr.textContent = fmt(p.price); a.appendChild(pr);
            li.appendChild(a); ul.appendChild(li);
          });
          pOut.innerHTML = ''; pOut.appendChild(ul);
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Warenkorb ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', !n); });
  }
  function refreshCart() {
    var jobs = [];
    var inner = $('[data-cart-drawer-inner]');
    if (inner) {
      jobs.push(fetch(L.routes.cart + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        if (fresh) inner.innerHTML = fresh.innerHTML;
      }));
    }
    var page = $('[data-cart-page-inner]');
    if (page) {
      jobs.push(fetch(L.routes.cart).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-page-inner]');
        if (fresh) page.innerHTML = fresh.innerHTML;
      }));
    }
    jobs.push(fetch(L.routes.cartJs).then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); }));
    /* Drawer/Seite wurden ersetzt: Cross-Sell-Platzhalter sind neu und müssen frisch geladen werden */
    return Promise.all(jobs).then(function () { loadUpsell(); });
  }
  /* Cross-Sell im Warenkorb: Recommendations-API (section_id=cart-upsell), je Platzhalter einmal */
  function loadUpsell(scope) {
    $$('[data-cart-upsell]', scope || document).forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.hasAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '');
      fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-upsell-result]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }
  var cartPage = $('[data-cart-page]');
  if (cartPage) loadUpsell(cartPage); /* Warenkorbseite sofort; der Drawer lädt beim Öffnen */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var box = b.closest('.cart-upsell'), err = box ? $('[data-upsell-error]', box) : null;
    if (err) err.hidden = true;
    b.disabled = true;
    fetch(L.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(b.getAttribute('data-upsell-add'), 10), quantity: 1 })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || L.strings.error); return j; }); })
      .then(refreshCart)
      .catch(function (ex) {
        b.disabled = false;
        if (err) { err.textContent = ex.message || L.strings.error; err.hidden = false; }
      });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = $('[data-line="' + b.getAttribute('data-line-change') + '"]', b.closest('.cart-lines') || document);
    if (line) line.classList.add('is-busy');
    fetch(L.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line-change'), 10), quantity: parseInt(b.getAttribute('data-qty-value'), 10) })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(refreshCart)
      .catch(function () { if (line) line.classList.remove('is-busy'); });
  });

  /* ---------- Reel ---------- */
  $$('.reel').forEach(function (reel) {
    var track = $('[data-reel]', reel);
    if (!track) return;
    var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }); };
    var p = $('[data-reel-prev]', reel), n = $('[data-reel-next]', reel);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
  });

  /* ---------- Filter: automatisch absenden ---------- */
  $$('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- Login/Passwort-Reset umschalten ---------- */
  $$('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var l = $('#LoginBox'), r = $('#RecoverBox');
      if (l && r) { l.hidden = !l.hidden; r.hidden = !r.hidden; }
    });
  });
  if (location.hash === '#recover') { var lb = $('#LoginBox'), rb = $('#RecoverBox'); if (lb && rb) { lb.hidden = true; rb.hidden = false; } }

  /* ---------- Empfehlungen nachladen ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-reveal]', el).forEach(function (x) { x.classList.add('is-visible'); });
      }
    }).catch(function () {});
  });

  /* ---------- Produktseite ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var dataEl = $('[data-variants]', sec);
    if (!dataEl) return;
    var info = JSON.parse(dataEl.textContent);
    var variants = info.variants;
    var form = $('.pdp__form', sec);
    var idInput = $('[data-variant-id]', sec);
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), stickyPrice = $('[data-price-sticky]', sec);
    var addBtn = $('[data-add]', sec), addLabel = $('[data-add-label]', sec);
    var stickyBtn = $('[data-sticky-add]', sec), sticky = $('[data-sticky-atc]', sec);
    var errEl = $('[data-form-error]', sec);
    var track = $('[data-gallery-track]', sec);
    var thumbs = $$('[data-thumb]', sec);

    function selectedOptions() {
      return $$('.opt', sec).map(function (f) {
        var c = $('input:checked', f);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      if (!opts.length) return variants[0];
      return variants.filter(function (v) { return opts.every(function (o, i) { return o === v.options[i]; }); })[0] || null;
    }
    function showMedia(id) {
      if (!track || !id) return;
      var slide = $('[data-media-id="' + id + '"]', track);
      if (slide && window.getComputedStyle(track).flexDirection === 'column') { slide.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); return; }
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    function setLabels(v) {
      var dis = !v || !v.available;
      var txt = !v ? 'Nicht verfügbar' : (v.available ? L.strings.addToCart : L.strings.soldOut);
      addBtn.disabled = dis; if (stickyBtn) { stickyBtn.disabled = dis; stickyBtn.textContent = txt; }
      addLabel.textContent = txt;
    }
    function onVariantChange() {
      var opts = selectedOptions();
      $$('.opt', sec).forEach(function (f, i) { var l = $('[data-option-label]', f); if (l) l.textContent = opts[i] || ''; });
      var v = findVariant(opts);
      setLabels(v);
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (cmpEl) { cmpEl.hidden = !v.compare; cmpEl.textContent = v.compare || ''; }
      if (v.mediaId) showMedia(v.mediaId);
      var u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
    $$('.opt input', sec).forEach(function (i) { i.addEventListener('change', onVariantChange); });

    /* Start: ?variant= auswählen */
    var qv = new URLSearchParams(location.search).get('variant');
    if (qv) {
      var sv = variants.filter(function (v) { return String(v.id) === qv; })[0];
      if (sv) $$('.opt', sec).forEach(function (f, i) {
        $$('input', f).forEach(function (inp) { inp.checked = inp.value === sv.options[i]; });
      });
    }
    onVariantChange();

    /* Galerie: Thumbnails + aktives Thumb */
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    if (track && 'IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.getAttribute('data-media-id');
            thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
          }
        });
      }, { threshold: 0.6 });
      $$('.gallery__slide', track).forEach(function (s) { gio.observe(s); });
    }

    /* Menge */
    var qty = $('.qty__input', sec);
    $$('[data-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
      });
    });

    /* In den Warenkorb (AJAX) */
    function add(e) {
      if (e) e.preventDefault();
      if (addBtn.disabled) return;
      errEl.hidden = true;
      addBtn.disabled = true;
      fetch(L.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || L.strings.error); return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () {
          var opener = $('.header__cart');
          if (document.getElementById('cart-drawer')) openDrawer('cart-drawer', opener);
        })
        .catch(function (err) { errEl.textContent = err.message || L.strings.error; errEl.hidden = false; })
        .then(function () { setLabels(findVariant(selectedOptions())); });
    }
    if (form) form.addEventListener('submit', add);
    if (stickyBtn) stickyBtn.addEventListener('click', add);

    /* Sticky-Leiste: sichtbar, sobald der Kauf-Button aus dem Bild ist */
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
      }).observe(addBtn);
    }

    /* Lightbox mit Zoom */
    var lb = $('[data-lightbox]');
    if (lb && typeof lb.showModal === 'function') {
      var imgs = $$('[data-lightbox-open]', sec).map(function (b) { return b.getAttribute('data-full'); });
      var idx = 0, lbImg = $('[data-lightbox-img]', lb);
      var show = function (i) { idx = (i + imgs.length) % imgs.length; lbImg.src = imgs[idx]; lbImg.classList.remove('is-zoomed'); };
      $$('[data-lightbox-open]', sec).forEach(function (b) {
        b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-lightbox-open'), 10)); lb.showModal(); });
      });
      $('[data-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
      $('[data-lightbox-prev]', lb).addEventListener('click', function () { show(idx - 1); });
      $('[data-lightbox-next]', lb).addEventListener('click', function () { show(idx + 1); });
      lbImg.addEventListener('click', function () { lbImg.classList.toggle('is-zoomed'); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
    }
  });
  /* ---------- Neukunden-Hinweis (Popup) ---------- */
  /* Erscheint nach 25 s oder 50 % Scrolltiefe (was zuerst eintritt), je Besucher einmal in 30 Tagen (localStorage lumori_promo_seen). */
  var promo = $('[data-promo]');
  if (promo && !O.designMode && !/^\/(checkout|cart|policies)/.test(location.pathname)) {
    var PROMO_KEY = 'lumori_promo_seen', PROMO_DAYS = 30;
    var promoSeen = function () {
      try {
        var t = parseInt(localStorage.getItem(PROMO_KEY), 10);
        return t > 0 && Date.now() - t < PROMO_DAYS * 864e5;
      } catch (err) { return false; }
    };
    var promoMark = function () { try { localStorage.setItem(PROMO_KEY, String(Date.now())); } catch (err) {} };
    if (!promoSeen()) {
      var promoOpen = false, promoPrev = null, promoTimer = 0;
      var promoCard = $('.promo__card', promo), promoCloseBtn = $('.promo__close', promo);
      var promoOnScroll = function () {
        var h = root.scrollHeight;
        if (h > 0 && (window.scrollY + window.innerHeight) / h >= 0.5) promoShow();
      };
      var promoClose = function () {
        if (!promoOpen) return;
        promoOpen = false;
        promo.hidden = true;
        document.removeEventListener('keydown', promoKey);
        if (promoPrev && promoPrev.focus) { try { promoPrev.focus(); } catch (err) {} }
      };
      var promoKey = function (e) {
        if (e.key === 'Escape') { promoClose(); return; }
        if (e.key !== 'Tab') return;
        var f = $$('a[href],button:not([disabled])', promoCard).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!promoCard.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      var promoShow = function () {
        if (promoOpen) return;
        /* Nicht über Drawer oder Lightbox legen – dann kurz später erneut versuchen */
        if (activeDrawer || $('dialog[open]')) { clearTimeout(promoTimer); promoTimer = setTimeout(promoShow, 4000); return; }
        promoOpen = true;
        clearTimeout(promoTimer);
        window.removeEventListener('scroll', promoOnScroll);
        promoMark();
        promoPrev = document.activeElement;
        promo.hidden = false;
        document.addEventListener('keydown', promoKey);
        if (promoCloseBtn) promoCloseBtn.focus();
      };
      $$('[data-promo-close]', promo).forEach(function (el) { el.addEventListener('click', promoClose); });
      var copyBtn = $('[data-promo-copy]', promo), codeEl = $('[data-promo-code]', promo);
      if (copyBtn && codeEl) {
        var copyLabel = copyBtn.textContent;
        copyBtn.addEventListener('click', function () {
          var code = codeEl.textContent.trim();
          var done = function () {
            copyBtn.textContent = promo.getAttribute('data-copied') || copyLabel;
            setTimeout(function () { copyBtn.textContent = copyLabel; }, 2500);
          };
          var fallback = function () {
            var ta = document.createElement('textarea');
            ta.value = code; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
            document.body.appendChild(ta); ta.select();
            try { if (document.execCommand('copy')) done(); } catch (err) {}
            document.body.removeChild(ta);
            copyBtn.focus();
          };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
          else fallback();
        });
      }
      promoTimer = setTimeout(promoShow, 25000);
      window.addEventListener('scroll', promoOnScroll, { passive: true });
    }
  }
  /* Cookie-Einstellungen: öffnet das Shopify-Cookie-Banner erneut (Widerruf der Einwilligung) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-settings]');
    if (!b) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'policies/privacy-policy';
    }
  });
})();
